import React, { useEffect, useState } from 'react';
import { Table, message, Modal } from 'antd';
import { DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import { getWaterAnalysisByExploitation, deleteWaterAnalysis } from '../../../Utils/analysis/waterAnalysis';
import Loading from '../../Shared/Loading';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';


const { confirm } = Modal;




const WaterAnalysis = () => {
  const { exploitationId } = useParams();
  const navigate = useNavigate();
  const [water, setWater] = useState([]);
  const [loading, setLoading] = useState(true);
  const userRole = useSelector((state) => state.user.userRole.name);

  const userLink = () => {
        if (userRole === 'client') {
          return '/client';
        } else if (userRole === 'admin' || userRole === 'superadmin') {
          return '/admin';
        } else if (userRole === 'domain_manager') {
          return '/domain-manager';
        } else if (userRole === 'exploitation_manager') {
          return '/exploitation-manager';
        }
      };
  useEffect(() => {
    fetchWater();
  }, [exploitationId]);

  const fetchWater = async () => {
    try {
      const response = await getWaterAnalysisByExploitation(exploitationId);
      setWater(response.data);
    } catch (error) {
      console.error('Error fetching water analyses:', error);
      message.error('Failed to fetch water analyses');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    confirm({
      title: 'Êtes-vous sûr de vouloir supprimer cette analyse d\'eau ?',
      icon: <ExclamationCircleOutlined />,
      content: 'Cette action est irréversible.',
      okText: 'Oui',
      okType: 'danger',
      cancelText: 'Non',
      onOk: async () => {
        try {
          await deleteWaterAnalysis(id);
          message.success('Analyse d\'eau supprimée avec succès');
          fetchWater();
        } catch (error) {
          console.error('Erreur lors de la suppression de l\'analyse d\'eau:', error);
          message.error('Échec de la suppression de l\'analyse');
        }
      },
    });
  };

  const handleEdit = (record) => {
    navigate(`/admin/exploitation/${exploitationId}/edit-water-analysis/${record.analysis_id}`);
  };

  const handleView = (record) => {
    navigate(`${userLink()}/exploitation/${exploitationId}/view-water-analysis/${record.analysis_id}`);
  };

  const handleCreateAnalysis = () => {
    navigate(`/admin/exploitation/${exploitationId}/create-water-analysis`);
  };

  const columns = [
    { title: 'Sample', dataIndex: 'echantillon', key: 'echantillon' },
    { title: 'Date', key: 'date_realisation', render: (_, record) => new Date(record.date_realisation).toLocaleDateString() },
    { title: 'Laboratory', dataIndex: 'laboratoire', key: 'laboratoire' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <span className="flex space-x-2">
          <EyeOutlined
            onClick={() => handleView(record)}
            className="text-green-500 text-2xl p-1 rounded-lg hover:bg-slate-200 cursor-pointer mr-4"
            />
          { (userRole === 'admin' || userRole === 'superadmin') &&
            <>
            <EditOutlined
              onClick={() => handleEdit(record)}
              className="text-blue-500 text-2xl p-1 rounded-lg hover:bg-slate-200 cursor-pointer mr-4"
              />
            <DeleteOutlined
              onClick={() => handleDelete(record.analysis_id)}
              className="text-red-500 text-2xl p-1 rounded-lg hover:bg-slate-200 cursor-pointer mr-4"
              />
          </>}
        </span>
      ),
    },
  ];

  return (
    <div className="w-full">
      {loading && <Loading />}
        <Table
          dataSource={water}
          columns={columns}
          rowKey="id"
        />
        { (userRole === 'admin' || userRole === 'superadmin') &&
          <button
                className="fixed flex items-center justify-center rounded-full shadow-lg bg-blue-500 w-16 h-16 bottom-10 right-10 text-white text-2xl cursor-pointer hover:bg-blue-600 transition duration-300 ease-in-out"
                onClick={handleCreateAnalysis}
        >
          <PlusOutlined />
        </button>}
    </div>
  );
};

export default WaterAnalysis ;